import React from "react"

export default ({input, brandColor}) => {
  let rememberMeStyle = {}
  if (input.value) {
    rememberMeStyle = {
      backgroundColor: brandColor
    };
  }
  return (
    <div style={rememberMeStyle} onClick={()=> {
      input.onChange(!input.value)
    }} className="checkbox" />
  );
};